module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-7-b00fd0f744875b2f52e7cdcb863246e9.jpg";